import CardCommon, { CardCommonType } from '@op/components/CardCommon';
import { DBO_V } from '@op/utils/format';
import React, { useMemo } from 'react';
import { Progress } from 'tea-component';
import classnames from 'classnames';
import './index.scss';
import useIntls from '@opm/hooks/useIntls';
import CountryItem from '@opm/pages/Hashtag/components/CountryItem';
import { hashtagTop5DetailTipsMap } from '@opm/components/BubbleCommon';

const defaultColorMap = ['#5086F3', '#5EC8F1', '#69D19C', '#F8D74D', '#7F6FF1'];

interface IDistributionProgress extends CardCommonType {
  data: Array<{
    country: string;
    [valueKey: string]: number | string;
  }>;
  valueKey: string;
  title: string;
  classNames?: string;
  colorMap?: string[];
  topCount?: number;
}
export default function DistributionProgress(props: IDistributionProgress) {
  const {
    data,
    valueKey,
    title,
    classNames,
    colorMap = defaultColorMap,
    topCount = 5,
    ...cardProps
  } = props;
  const { intl, isEn } = useIntls();

  const formatData = useMemo(() => {
    const dataList = data || [];
    const sortedList = [...dataList]
      .filter((item) => (Number(item?.[valueKey]) > 0) && item?.country !== 'all')
      .sort((a, b) => Number(b?.[valueKey] || 0) - Number(a?.[valueKey] || 0));
    const topList = sortedList.slice(0, topCount);
    const maxValue = Number(topList[0]?.[valueKey]) || 0;
    return topList.map((val, index) => {
      const { country } = val;
      const value = Number(val?.[valueKey]) || 0;
      const color = colorMap[index];
      const percent = maxValue > 0 ? +((value / maxValue) * 100).toFixed(2) : 0;

      return { country, value, percent, color };
    });
  }, [data, valueKey]);

  return (
    <CardCommon
      title={intl(title)}
      {...cardProps}
      className={classnames('dbom-hashtag-distribution-progress', classNames)}
      empty={formatData?.length === 0}
      emptyHeight={130}
      hasEmptyImg={false}
    >
      <div className="dbom-hashtag-distribution-progress-content">
        {formatData?.map((val) => (
          <DistributionProgressItem key={val.country} isEn={isEn} {...val} />
        ))}
        {formatData?.length < 5 && (
          <div className="dbom-hashtag-distribution-progress-empty">
            {hashtagTop5DetailTipsMap[isEn ? 'en' : 'zh']}
          </div>
        )}
      </div>
    </CardCommon>
  );
}

const DistributionProgressItem = (props: {
  country: string;
  value: number;
  color: string;
  percent: number;
  isEn: boolean;
}) => {
  const { country, value, color, percent } = props;

  return (
    <div className="dbom-hashtag-distribution-progress-item">
      <div className="distribution-item-left">
        <CountryItem
          country={country}
        ></CountryItem>
        <Progress
          percent={percent}
          strokeColor={color}
          className="dbom-hashtag-distribution-progress-item-progress"
        />
      </div>
      <span className="dbom-hashtag-distribution-progress-item-value">
        {DBO_V.reviews(value)}
      </span>
    </div>
  );
};
